import React, { useEffect, useState, useRef } from 'react';
import ReactPlayer from 'react-player'
import Header from '../Components/Header';
import { Link } from 'react-router-dom';
import { Box, Button, Grid, styled, Typography } from '@mui/material';
import { BackgroundBox } from '../Styles/Background';
import { BlackButton, OutlinedWhiteButton } from '../Styles/Button';
import { TextBox } from '../Styles/Box';
import Footer from '../Components/Footer';
import VideoPlayer from '../Components/VideoPlayer';
import ImageDisplayer from '../Components/ImageDisplayer';
import grape from '../Assets/grape.webp';
import grapeAfternoon from '../Assets/grapeAfternoon.webp';
import grapeEvening from '../Assets/grapeEvening.webp';
import multipleGrape from '../Assets/multipleGrape.webp';
import hand from '../Assets/hand.webp';
import ice from '../Assets/ice.webp';
import cuves from '../Assets/cuves.webp';
import raisinsRouges from '../Assets/raisinsRouge.webp';
import walk from '../Assets/walk.webp';
import samLechai from '../Assets/samLechai.webp';
import land from '../Assets/land.webp';
import sunset from '../Assets/sunset.webp';
import barrel from '../Assets/barrel.webp';


export const Home = (props) => {
  const { scrollToEl } = props;

  const titleRef = useRef(scrollToEl);
  
  const scrollTo = (ref) => {
    if (ref && ref.current) {
      titleRef.current.scrollIntoView({behavior: 'smooth', block: 'center'});
    }
  };

  useEffect(() => {
    if (scrollToEl) {
      scrollTo(titleRef);
    }
  }, [scrollToEl]);

  return (
    <div>
      <BackgroundBox>
      <Header/>
      <meta name="description" content="Le Chai Metz : un chai urbain"/>
      <Box sx={{ backgroundColor: 'transparent', position: 'relative', zIndex: 1}}>
      <Grid container>
      
      <Grid item xs={12}>
        <Box // Contenant infos et photo //
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'center',
            alignItems: 'center',
            margin: { xs: 1, md: 2 },
            padding: 5,
            backgroundColor: '#FBFCFA',
            height: '500px',
            minHeight: 'fit-content',
            columnGap: 10,
            borderRadius: 10,
          }}
        >
          <ImageDisplayer img={hand} description='technique de remontage' type='large'/>
          <Box // Text et Bouton dans le contenant //
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              textAlign: {xs: 'center', md: 'start'},
              alignItems: {xs: 'center', md: 'start'},
              maxWidth: { xs: '90%', md: '40%' },
            }}
          >
            <Typography variant='h3' component='h1' ref={'Qui sommes nous' === scrollToEl ? titleRef : null}
              sx={{
                py: 1,
                color: '#16191e',
                fontSize: {xs: 35, md: 45},
                textAlign: {sm: 'center', md: 'start'},
                letterSpacing: 1.5,
              }}
            >
              Qui sommes nous ?
            </Typography>
            <Typography variant='p' component='p'
              sx={{
                py: 1,
                fontSize: 18,
                lineHeight: 1.3,
                color: '#16191e',
                textAlign: {xs: 'center', md: 'start'}
              }}
            >
              Le chai, c’est d’abord l’histoire d’une passion, d’un itinéraire, d’une reconversion : 
              le pari un peu fou de faire ce qu’on a toujours voulu faire.
            </Typography>
            <Typography variant='p' component='p'
              sx={{
                fontSize: 18,
                py: 1,
                lineHeight: 1.3,
                color: '#16191e',
                textAlign: {xs: 'center', md: 'start'},
              }}
            >
              Après des études de médecine et une carrière dans le management hospitalier, j’ai fait le
              choix de me consacrer à un projet en lien avec la création de vins éco-responsables, relocalisés,
              vertueux, conçus à la fois dans le respect de la tradition et dans une volonté d’innovation et de
              découverte.       
            </Typography>
            <OutlinedWhiteButton
              variant="outlined"
              component={Link}
              to={'/contact'}
              sx={{
                width: '80%',
                fontWeight: 600,
                my: 5,
                py : 1.5,
              }}
            >
              Nous contacter
            </OutlinedWhiteButton>
          </Box>
        </Box>
        </Grid>
        <Grid item xs={12}>
        <Box // Contenant infos et photo //
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row-reverse' },
            justifyContent: 'center',
            alignItems: 'center',
            margin: { xs: 1, md: 2 },
            padding: 5,
            backgroundColor: '#FBFCFA',
            height: '500px',
            minHeight: 'fit-content',
            columnGap: 10,
            borderRadius: 10,
          }}
        >
          <ImageDisplayer img={cuves} description='cuves du chai' type='large'/>
          <Box // Text et Bouton dans le contenant //
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              textAlign: {xs: 'center', md: 'start'},
              alignItems: {xs: 'center', md: 'start'},
              maxWidth: { xs: '90%', md: '40%' },
            }}
          >
            <Typography variant='h3' component='h1' ref={'Un chai urbain' === scrollToEl ? titleRef : null}
              sx={{
                py: 1,
                color: '#16191e',
                fontSize: {xs: 35, md: 45},
                textAlign: {sm: 'center', md: 'start'},
                letterSpacing: 1.5,
              }}
            >
              Un chai urbain ?
            </Typography>
            <Typography variant='p' component='p'
              sx={{
                py: 1,
                fontSize: 18,
                lineHeight: 1.3,
                color: '#16191e',
                textAlign: {xs: 'center', md: 'start'}
              }}
            >
              Un chai en cœur de ville, c’est surtout un rapprochement : celui entre le vin et sa
              communauté. Tous les vins que nous concevons sont élaborés sur place, dans un lieu
              géographiquement à portée du consommateur.
            </Typography>
            <Typography variant='p' component='p'
              sx={{
                fontSize: 18,
                py: 1,
                lineHeight: 1.3,
                color: '#16191e',
                textAlign: {xs: 'center', md: 'start'},
              }}
            >
              Venez découvrir le processus de vinification, participer à des ateliers d’assemblage ou
              d’immersion, créer votre propre cuvée, et bien sûr déguster des crus uniques.         
            </Typography>
            <OutlinedWhiteButton
              variant="outlined"
              component={Link}
              to={'/ateliers'}
              sx={{
                width: '80%',
                fontWeight: 600,
                my: 5,
                py : 1.5,
              }}
            >
              Nos ateliers
            </OutlinedWhiteButton>
          </Box>
        </Box>
        </Grid>
        <Grid item xs={12}>
          <Box // Text en dehors du contenant //
            sx={{
              position: 'relative',
              display: 'flex',
              textAlign: 'center',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              marginX: 'auto',
              marginTop: 3,
              maxWidth: { xs: '90%', md: '80%' },
            }}
          >
            <Typography variant='h3' component='h1' ref={'Prestations' === scrollToEl ? titleRef : null}
              sx={{
                py: 1,
                color: '#16191e',
                fontSize: {xs: 35, md: 45},
                textAlign: {sm: 'center', md: 'start'},
                letterSpacing: 1.5,
              }}
            >
              Prestations
            </Typography>
            <Typography variant='p' component='p'
              sx={{
                fontSize: 18,
                py: 1,
                lineHeight: 1.3,
                color: '#16191e',
                textAlign: 'center',
              }}
            >
              Notre point fort ? La capacité de faire du sur-mesure, en fonction de vos envies, de vos goûts, de
              votre budget.<br /> Au chai nous vous proposons :<br />

            </Typography>
            <Box 
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                textAlign: 'center',
                alignItems: 'center',
                width: {sm:'90%', md: '70%'},
                columnGap: 10,
              }}
            >
            <Typography variant='p' component='p'
              sx={{
                fontSize: 18,
                lineHeight: 1.3,
                color: '#16191e',
                textAlign: 'left',
              }}
            >
              <ul>
                <li style={{ marginBottom: '20px' }}>Des visites et dégustations gratuites, sur des créneaux dédiés, ou sur rendez-vous.</li>
                <li style={{ marginBottom: '20px' }}>Des ateliers d’assemblages, que vous soyez néophytes ou confirmés : aucun problème, nous nous adaptons à votre niveau.</li>
                <li style={{ marginBottom: '20px' }}>Des journées d’immersion : « dans la peau d’un vinificateur », vous partagez une journée de travail au chai et participez à différentes étapes de la vinification !</li>
                <li style={{ marginBottom: '20px' }}>La réalisation de votre propre cuvée ! Que vous soyez un particulier ou un professionnel, nous pouvons créer avec vous vos bouteilles et leur contenu ! Du choix du cépage à l’étiquetage final, vous êtes aux commandes et bien entourés !</li>
              </ul>
            </Typography>
            </Box>
            <Box // Contenant images //
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: {xs: '200px', md: '500px'},
                paddingBottom: {xs: 1, md: 0},
              }}
            >
              <ImageDisplayer img={hand} description='technique de remontage' type='small'/>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box // Contenant infos et photo //
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column-reverse', md: 'row' },
              justifyContent: 'center',
              alignItems: 'center',
              margin: { xs: 1, md: 2 },
              padding: 5,
              backgroundColor: '#FBFCFA',
              height: '700px',
              minHeight: 'fit-content',
              columnGap: 10,
              borderRadius: 10,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection:{ xs: 'column', md: 'column' },
                justifyContent: 'center',
                alignItems: 'center',
                maxWidth: '100%',
                maxHeight: '700px',
                overflow: 'hidden'
              }}
            >
              <ImageDisplayer img={ice} description='glace carbonique' type='xlarge'/>
              <ImageDisplayer img={barrel} description='entonnage des fûts' type='xlarge'/>
            </Box>
            <Box // Text et Bouton dans le contenant //
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                textAlign: {xs: 'center', md: 'start'},
                alignItems: {xs: 'center', md: 'start'},
                maxWidth: { xs: '90%', md: '40%' },
              }}
            >
              <Typography variant='h3' component='h1' ref={'Vinification' === scrollToEl ? titleRef : null}
                sx={{
                  py: 1,
                  color: '#16191e',
                  fontSize: {xs: 35, md: 45},
                  textAlign: {sm: 'center', md: 'start'},
                  letterSpacing: 1.5,
                }}
              >
                Vinification
              </Typography>
              <Typography variant='p' component='p'
                sx={{
                  fontSize: 18,
                  py: 1,
                  lineHeight: 1.3,
                  color: '#16191e',
                  textAlign: {xs: 'center', md: 'start'}
                }}
              >
                Vendangé à la main, le raisin est conditionné,
                le jour même, en caisse de 220 litres, refroidi et
                privé d’oxygène pour voyager dans les meilleures
                conditions et arriver au chai le soir dans le même
                état sanitaire que lors de la vendange du matin.
              </Typography>
              <Typography variant='p' component='p'
                sx={{
                  fontSize: 18,
                  py: 1,
                  lineHeight: 1.3,
                  color: '#16191e',
                  textAlign: {xs: 'center', md: 'start'},
                }}
              >
                Une fois au chai, le raisin est, soit encuvé pour les rouges, soit pressé directement pour les
                cépages blancs.
                Après les différentes phases de fermentations et de transformations malolactiques
                éventuelles, le raisin est élevé en cuve inox ou en barrique, selon le cépage et la structure
                aromatique recherchée.
                La qualité du raisin et de la vendange permet de limiter significativement les intrants et le
                sulfitage.
              </Typography>
              <Typography variant='p' component='p'
                sx={{
                  fontSize: 18,
                  py: 1,
                  lineHeight: 1.3,
                  color: '#16191e',
                  textAlign: {xs: 'center', md: 'start'},
                }}
              >
                Une dernière étape consiste à filtrer les vins avant de les mettre en bouteille. Vous pouvez
                alors les déguster. Retrouvez notre production 2024 sur la page des produits mis en vente, chacun
                d’eux étant assorti de sa fiche technique.
              </Typography>
              <OutlinedWhiteButton
              variant="outlined"
              component={Link}
              to={'/boutique'}
              sx={{
                width: '80%',
                fontWeight: 600,
                my: 5,
                py : 1.5,
              }}
            >
              Nos produits
            </OutlinedWhiteButton>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box // Text en dehors du contenant //
            sx={{
              position: 'relative',
              display: 'flex',
              textAlign: 'center',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              marginX: 'auto',
              marginY: 1,
              maxWidth: { xs: '90%', md: '80%' },
            }}
          >
            <Typography variant='h3' component='h1' ref={'Philosophie viticole' === scrollToEl ? titleRef : null}
              sx={{
                py: 1,
                color: '#16191e',
                fontSize: {xs: 35, md: 45},
                textAlign: {sm: 'center', md: 'start'},
                letterSpacing: 1.5,
              }}
            >
              Philosophie viticole
            </Typography>
            <Typography variant='p' component='p'
              sx={{
                fontSize: 18,
                paddingTop: 1,
                lineHeight: 1.3,
                color: '#16191e',
                textAlign: 'center',
              }}
            >
              L’aventure commence par la recherche de raisins de qualité, à travers la France, grâce à
              des vignerons respectueux de leur terroir et de la biodiversité. Implantés depuis plusieurs années
              en agriculture biologique (Demeter), on les trouve très souvent dans des zones où la vigne vit en
              symbiose avec d’autres éléments (forêt, arbres fruitiers, oliviers,…).
            </Typography>
            <Box // Contenant images //
              sx={{
                display: 'flex',
                flexDirection:{ xs: 'column', md: 'row' },
                justifyContent: 'center',
                alignItems: 'center',
                height: '400px',
                columnGap: 5,
              }}
            >
              <ImageDisplayer img={grapeAfternoon} description='vignes en agriculture biologique' type='small'/>
              <ImageDisplayer img={grapeEvening} description='vignes en agriculture biologique' type='small'/>
            </Box>
            <Typography variant='p' component='p'
              sx={{
                fontSize: 18,
                py: 0,
                lineHeight: 1.3,
                color: '#16191e',
                textAlign: 'center',
              }}
            >
              La sélection de vieilles vignes, l’utilisation limitée d’intrants chimiques, des amendements
              mesurés ainsi que la conduite de la vigne (ébourgeonnage précoce…) sont autant de facteurs qui
              limitent les rendements (entre 15 et 35 hl/ha), assurant ainsi la qualité des parcelles que nous
              sélectionnons.
            </Typography>
            <Typography variant='p' component='p'
              sx={{
                fontSize: 18,
                paddingBottom: 1,
                lineHeight: 1.3,
                color: '#16191e',
                textAlign: 'center',
              }}
            >
              <br/>De concert avec les producteurs, nous décidons de maturités optimales au regard des vins
              que nous souhaitons obtenir. Ce sont ces maturités qui déclenchent des vendanges
              personnalisées et paramétrées pour le Chai.
            </Typography>
            <Box // Contenant images //
              sx={{
                display: 'flex',
                flexDirection:{ xs: 'column', md: 'row' },
                justifyContent: 'center',
                alignItems: 'center',
                height: '400px',
                columnGap: 10,
              }}
            >
              <ImageDisplayer img={grape} description='grappe de raisin Carignan' type='medium'/>
              <ImageDisplayer img={raisinsRouges} description='chapeau de marc' type='medium'/>
            </Box>
            <Typography variant='p' component='p'
              sx={{
                fontSize: 18,
                paddingBottom: 1,
                lineHeight: 1.3,
                color: '#16191e',
                textAlign: 'center',
              }}
            >
              Merci à Claire, Stéphanie, Anne-Sophie, Romain, Benoit et Florian pour leur
              engagement extraordinaire en faveur de la qualité et de l’excellence.
            </Typography>
            </Box>
        </Grid>
        {/* <Grid item xs={12} md={6}>
          <Box // Contenant infos et photo 1/2 //
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              margin: { xs: 1, md: 2 },
              py: 1,
              backgroundColor: '#FBFCFA',
              height: '700px',
              columnGap: 10,
              borderRadius: 10,
            }}
          >
            <ImageDisplayer img={sunset} description='sunset' type='small'/>
            <Box // Text et Bouton dans le contenant //
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                textAlign: {xs: 'center', md: 'start'},
                alignItems: {xs: 'center', md: 'start'},
                maxWidth: { xs: '90%', md: '80%' },
              }}
            >
              <Typography variant='h3' component='h1' ref={titleRef}
                sx={{
                  py: 1,
                  color: '#16191e',
                  fontSize: {xs: 35, md: 45},
                  textAlign: {sm: 'center', md: 'start'},
                  letterSpacing: 1.5,
                }}
              >
                Vinification 1/2
              </Typography>
              <Typography variant='p' component='p'
                sx={{
                  fontSize: 18,
                  py: 1,
                  lineHeight: 1.3,
                  color: '#16191e',
                  textAlign: {xs: 'center', md: 'start'}
                }}
              >
                Vendangé à la main, le raisin est conditionné,
                le jour même, en caisse de 220 litres, refroidi et
                privé d’oxygène pour voyager dans les meilleures
                conditions et arriver au chai le soir dans le même
                état sanitaire que lors de la vendange du matin.
              </Typography>
              <Typography variant='p' component='p'
                sx={{
                  fontSize: 18,
                  py: 1,
                  lineHeight: 1.3,
                  color: '#16191e',
                  textAlign: {xs: 'center', md: 'start'},
                }}
              >
                Une fois au chai, le raisin est, soit encuvé pour les rouges, soit pressé directement pour les
                cépages blancs. Après les différentes phases de fermentations et de transformations malolactiques
                éventuelles, le raisin est élevé en cuve inox ou en barrique, selon le cépage et la structure
                aromatique recherchée.
              </Typography>
              <OutlinedWhiteButton
              variant="outlined"
              sx={{
                width: '80%',
                fontWeight: 600,
                my: 5,
                py : 1.5,
              }}
            >
              En savoir plus
            </OutlinedWhiteButton>
          </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box // Contenant infos et photo 2/2 //
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              margin: { xs: 1, md: 2 },
              py: 1,
              backgroundColor: '#FBFCFA',
              height: '700px',
              columnGap: 10,
              borderRadius: 10,
            }}
          >
            <ImageDisplayer img={barrel} description='barrel' type='small'/>
            <Box // Text et Bouton dans le contenant //
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                textAlign: {xs: 'center', md: 'start'},
                alignItems: {xs: 'center', md: 'start'},
                maxWidth: { xs: '90%', md: '80%' },
              }}
            >
              <Typography variant='h3' component='h1' ref={titleRef}
                sx={{
                  py: 1,
                  color: '#16191e',
                  fontSize: {xs: 35, md: 45},
                  textAlign: {sm: 'center', md: 'start'},
                  letterSpacing: 1.5,
                }}
              >
                Vinification 2/2
              </Typography>
              <Typography variant='p' component='p'
                sx={{
                  fontSize: 18,
                  py: 1,
                  lineHeight: 1.3,
                  color: '#16191e',
                  textAlign: {xs: 'center', md: 'start'}
                }}
              >
                La qualité du raisin et de la vendange permet de limiter significativement les intrants et le
                sulfitage.
              </Typography>
              <Typography variant='p' component='p'
                sx={{
                  fontSize: 18,
                  py: 1,
                  lineHeight: 1.3,
                  color: '#16191e',
                  textAlign: {xs: 'center', md: 'start'},
                }}
              >
                Une dernière étape consiste à filtrer les vins avant de les mettre en bouteille. Vous pouvez
                alors les déguster. Retrouvez notre production 2024 sur la page des produits mis en vente, chacun
                d’eux étant assorti de sa fiche technique.
              </Typography>
              <OutlinedWhiteButton
              variant="outlined"
              component={Link}
              to={'/boutique'}
              sx={{
                width: '80%',
                fontWeight: 600,
                my: 5,
                py : 1.5
              }}
            >
              Nos produits
            </OutlinedWhiteButton>
          </Box>
          </Box>
        </Grid> */}
      </Grid>
      </Box>
      </BackgroundBox>
    </div>
  );
};

export default Home;

// 800e13 5c0000 9a060d //